const StudyOption =
    [

        {
            "id": "mocktest",
            "name": "PYQ Mock Test",
            "link": "/pyq-mock-test",
            "symbol": "📜",
            "status": "true"
        },
        {
            "id": "syllabus",
            "name": "JEE Syllabus",
            "link": "/syllabus",
            "symbol": "🗺️",
            "status": "true"
        },
        {
            "id": "ncertbook",
            "name": "NCERT Book",
            "link": "/ncert-book",
            "symbol": "📖",
            "status": "true"
        },
        {
            "id": "chapterwisepyq",
            "name": "Chapter wise PYQ",
            "link": "/chapter-wise-pyq",
            "symbol": "❔",
            "status": "true"
        },
        {
            "id": "formula",
            "name": "JEE Formula Sheet",
            "link": "/formula",
            "symbol": "🧮",
            "status": "true"
        },
        {
            "id": "mnemonic",
            "name": "JEE Mnemonics",
            "link": "/mnemonic",
            "symbol": "💡",
            "status": "true"
        },
        {
            "id": "mindmap",
            "name": "JEE Mind Map",
            "link": "/mindmap",
            "symbol": "🧠",
            "status": "true"
        },
        {
            "id": "flashcard",
            "name": "JEE Flashcard",
            "link": "/flashcard",
            "symbol": "🎴",
            "status": "true"
        },
        {
            "id": "toppernote",
            "name": "JEE Topper Note",
            "link": "/toppernote",
            "symbol": "🏅",
            "status": "true"
        },
        {
            "id": "repeatedpyq",
            "name": "Top Important PYQ",
            "link": "/repeated-pyq",
            "symbol": "🏆",
            "status": "true"
        },
        {
            "id": "chapterwiseweightage",
            "name": "Chapter-wise Weightage",
            "link": "/chapter-wise-weightage",
            "symbol": "⚖️",
            "status": "true"
        },
        {
            "id": "studyplaner",
            "name": "JEE Study Planner",
            "link": "/jee-main-study-planner",
            "symbol": "🗓️",
            "status": "true"
        },
        {
            "id": "studytimetable",
            "name": "JEE Study Timetable",
            "link": "/jee-main-study-time-table",
            "symbol": "⏰",
            "status": "true"
        },




    ]




export default StudyOption;